import { render } from "./MedicareNumber.vue?vue&type=template&id=8f922d18&scoped=true"
import script from "./MedicareNumber.vue?vue&type=script&lang=js"
export * from "./MedicareNumber.vue?vue&type=script&lang=js"

import "./MedicareNumber.vue?vue&type=style&index=0&id=8f922d18&scoped=true&lang=css"

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-57de6a73e2/0/cache/vue-loader-npm-17.4.2-00674d01e5-88760fe6a5.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f922d18"]])

export default __exports__